export default __webpack_public_path__ + "static/media/Ballroll_00356.74e6df07.png";